export function init( node ) {
	function setState() {
		const target    = window.innerHeight / 2;
		const distances = [];

		for ( const child of node.children ) {
			const { top, height } = child.getBoundingClientRect();
			const midPoint        = top + ( height / 2 );
			const distance        = Math.abs( midPoint - target );

			distances.push( distance );
		}

		const closest = distances.indexOf( Math.min( ...distances ) );

		if ( node.children[ closest ].dataset.backgroundColor ) {
			node.style.backgroundColor = node.children[ closest ].dataset.backgroundColor;
		} else {
			node.style.backgroundColor = 'transparent';
		}
	}

	for ( const child of node.children ) {
		child.dataset.backgroundColor = getComputedStyle( child ).backgroundColor;
		child.classList.add( 'color-fade__item' );
	}

	setState();
	window.addEventListener( 'scroll', setState );
	window.addEventListener( 'resize', setState );

	setTimeout( () => node.classList.add( 'color-fade--ready' ), 1000 );
}

document.querySelectorAll( '.color-fade' ).forEach( init );
